import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const PaletteIcon = createSvgIcon(
  <>
    <title>palette</title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      strokeWidth="1"
      transform="translate(0.5 0.5)"
    >
      <path
        d="M1,15 C1,9.9,3.5,5.4,7.4,2.7c1.4-1,3.6-1.2,4.6,0c1.3,1.7-1,4.1,0,5.5c2.7,3.3,8.4-3.2,15.1,0c4.8,2.4,4.1,8.7,3.5,11 c-1.8,6.3-7.6,11-14.5,11C7.8,30.1,1,23.4,1,15z"
        fill="none"
        stroke="#222222"
        strokeMiterlimit="10"
      />{' '}
      <circle
        cx="23"
        cy="14"
        data-color="color-2"
        fill="none"
        r="3"
        strokeMiterlimit="10"
      />{' '}
      <circle
        cx="7"
        cy="14"
        data-color="color-2"
        fill="none"
        r="2"
        strokeMiterlimit="10"
      />{' '}
      <circle
        cx="9"
        cy="21"
        data-color="color-2"
        fill="none"
        r="2"
        strokeMiterlimit="10"
      />{' '}
      <circle
        cx="16"
        cy="24"
        data-color="color-2"
        fill="none"
        r="2"
        strokeMiterlimit="10"
      />
    </g>
  </>
)
